/* eslint-disable no-unused-vars */
import { Button } from "primereact/button";
import { FunctionComponent, useState, useEffect } from "react";
import LoginStyles from "../authentication/login/login.module.css";
import Logo from "assets/adroit_logo.png";
import { InputText } from "primereact/inputtext";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Loader from "common/Loader";
import { setToaster } from "common/toastStore";
import { Ipassword } from "types/common-types";
import { useNavigate, useParams } from "react-router-dom";
import AuthService from "services/AuthService";
import TokenService from "services/TokenService";

interface CompleteRegistrationProps {}

const CompleteRegistration: FunctionComponent<
  CompleteRegistrationProps
> = () => {
  TokenService.removeUser();
  const params = useParams();
  let navigate = useNavigate();
  console.log(params); // {id: '1'}
  const [password, setPassword] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);
  const [countdown, setCountdown] = useState(5);

  const validationSchema = Yup.object().shape({
    password: Yup.string().required("Password is required"),
    passwordConfirmation: Yup.string().oneOf(
      [Yup.ref("password"), null],
      "Passwords must match"
    ),
  });

  const formOptions = {
    resolver: yupResolver(validationSchema),
    mode: "onBlur",
  };
  const { register, handleSubmit, formState } = useForm<Ipassword>(
    formOptions as object
  );
  const { errors, isValid } = formState;

  const onSubmit = (data: any) => {
    if (isValid) {
      setLoading(true);
      AuthService.userReg(params?.id, data?.password).then(
        (_response: any) => {
          setLoading(false);
          setToaster({
            severity: "success",
            summary: "Success",
            detail: "Registration completed successfully!",
          });
          setShowSuccessScreen(true);
          setCountdown(5);
        },
        (error: { response: { data: any[] } }) => {
          console.log(error);
          setToaster({
            severity: "error",
            summary: "Error Message",
            detail: error.response.data[0],
          });
          setLoading(false);
        }
      );
    }
  };

  // Countdown effect
  useEffect(() => {
    if (showSuccessScreen && countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (showSuccessScreen && countdown === 0) {
      navigate("../login");
    }
  }, [showSuccessScreen, countdown, navigate]);
  return (
    <>
      <div className={LoginStyles.login_bg}>
        {showSuccessScreen ? (
          <div className="m-auto">
            <div className="mb-6 flex justify-center">
              <img src={Logo} alt="Adroit Logo" />
            </div>
            <div className="bg-white w-96 rounded-2xl p-6 shadow-lg m-auto text-center">
              <div className="mb-4">
                <i
                  className="pi pi-check-circle text-green-500"
                  style={{ fontSize: "4rem" }}
                ></i>
              </div>
              <h2 className="text-xl font-bold mb-4">
                Registration Completed Successfully
              </h2>
              <p className="text-md mb-6">
                Your account has been activated. You will be redirected to login
                screen in{" "}
                <span className="font-bold text-xl text-blue-600">
                  {countdown}
                </span>{" "}
                seconds.
              </p>
            </div>
          </div>
        ) : (
          <form name="" onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-6 flex justify-center">
              <img src={Logo} alt="" />
            </div>
            <div className="bg-white w-96 rounded-2xl	p-6 shadow-lg">
              <h1 className="text-center text-2xl	font-bold">HELLO!</h1>
              <p className="text-center text-md	font-medium py-1">
                Activate your account here.
              </p>
              <div className="my-4 relative z-0 w-full ">
                <div className="">
                  <label htmlFor="userName" className="text-sm">
                    Enter Password
                  </label>
                  <InputText
                    id="userName"
                    {...register("password")}
                    name="password"
                    type="password"
                    className="w-full text-sm"
                  />
                </div>
                <div className="text-xs text-red-900">
                  {errors?.password?.message}
                </div>
              </div>
              <div className="my-4 relative z-0 w-full ">
                <div className="">
                  <label htmlFor="confirmPassword" className="text-sm">
                    Confirm Password
                  </label>
                  <InputText
                    id="confirmPassword"
                    {...register("passwordConfirmation")}
                    name="passwordConfirmation"
                    type="password"
                    className="w-full text-sm"
                  />
                </div>
                <div className="text-xs text-red-900">
                  {errors?.passwordConfirmation?.message}
                </div>
              </div>
              <div className="">
                <Button
                  label="Submit"
                  type="submit"
                  className={LoginStyles.login_submit}
                />
              </div>
            </div>
          </form>
        )}
      </div>
      {loading ? <Loader /> : null}
    </>
  );
};

export default CompleteRegistration;
